export const FETCH_INITIAL_DATA_FOR_TAX_ACCOUNTING_MODAL = 'FETCH_INITIAL_DATA_FOR_TAX_ACCOUNTING_MODAL';
export const FETCH_INITIAL_DATA_FOR_TAX_ACCOUNTING_MODAL_SUCCESS = 'FETCH_INITIAL_DATA_FOR_TAX_ACCOUNTING_MODAL_SUCCESS';
export const FETCH_INITIAL_DATA_FOR_TAX_ACCOUNTING_MODAL_FAILURE = 'FETCH_INITIAL_DATA_FOR_TAX_ACCOUNTING_MODAL_FAILURE';
